import I18n from 'I18n';
import { UPDATE_SEARCH_QUERY, UPDATE_FILTER_STATE, UPDATE_FILTER_CAMPAIGN, UPDATE_FILTER_CONTAINER_TYPE, CLEAR_FILTERS, UPDATE_DATE_RANGE, UPDATE_PATH_PARAMS } from '../actions/ActionTypes';
import * as DateRangePresets from 'foundations-components/transitional/components/Dates';
import * as SimpleDate from 'foundations-components/transitional/utils/SimpleDate';
import { getQueryParamsFromLocation } from 'web-interactives-dashboard-ui/utils/urls';
import { VALID_STATE_VALUES } from 'web-interactives-dashboard-ui/constants/properties';
const initialSearchParams = getQueryParamsFromLocation(window.location);
const simpleDateFromQuery = formattedDate => {
  const values = formattedDate.split('-').map(Number);
  return SimpleDate.make(values[0], values[1] - 1, values[2]);
};
const isValidDatePreset = dateType => !!dateType && Object.keys(DateRangePresets).includes(dateType);
const getInitialDateRangeProps = () => {
  if (initialSearchParams.startDate) {
    return {
      startDate: simpleDateFromQuery(initialSearchParams.startDate),
      endDate: simpleDateFromQuery(initialSearchParams.endDate || I18n.moment().format('YYYY-MM-YY')),
      dateType: undefined
    };
  } else if (isValidDatePreset(initialSearchParams.dateType)) {
    const dateRangePreset = DateRangePresets[initialSearchParams.dateType];
    return Object.assign({
      dateType: dateRangePreset.presetId
    }, dateRangePreset.getValue());
  } else {
    return {
      startDate: undefined,
      endDate: undefined,
      dateType: undefined
    };
  }
};
const getFilterValuesFromSearchParams = () => Object.assign({}, getInitialDateRangeProps(), {
  containerType: initialSearchParams.containerType,
  campaignId: initialSearchParams.campaignId
});
const isValidState = state => VALID_STATE_VALUES.includes(state) || state === 'scheduled' || Boolean(parseInt(state, 10));
const getInitialFilterState = () => {
  if (!window.location.pathname.includes('state')) {
    return 'all';
  }
  const pathValues = window.location.pathname.split('/');
  const maybeState = pathValues[pathValues.length - 1];
  return isValidState(maybeState) ? maybeState : 'all';
};
const defaultFiltersState = Object.assign({
  state: getInitialFilterState(),
  searchQuery: initialSearchParams.query || undefined,
  interactiveId: undefined
}, getFilterValuesFromSearchParams());
const filters = (state = defaultFiltersState, action) => {
  switch (action.type) {
    case UPDATE_PATH_PARAMS:
      {
        const {
          pathParams
        } = action;
        const maybeState = pathParams.length ? pathParams[pathParams.length - 1].toLowerCase() : '';
        if (pathParams.includes('manage') && isValidState(maybeState)) {
          return Object.assign({}, state, {
            state: maybeState
          });
        }
        if (pathParams.includes('details')) {
          return Object.assign({}, state, {
            interactiveId: Number(pathParams[1])
          });
        }
        return Object.assign({}, state, {
          state: 'all'
        });
      }
    case UPDATE_FILTER_CONTAINER_TYPE:
      return Object.assign({}, state, {
        containerType: action.containerType || undefined
      });
    case UPDATE_SEARCH_QUERY:
      return Object.assign({}, state, {
        searchQuery: action.searchQuery || undefined
      });
    case UPDATE_FILTER_STATE:
      return Object.assign({}, state, {
        state: action.filterState
      });
    case UPDATE_FILTER_CAMPAIGN:
      return Object.assign({}, state, {
        campaignId: action.campaignId || undefined
      });
    case CLEAR_FILTERS:
      {
        return Object.assign({}, defaultFiltersState, {
          startDate: undefined,
          endDate: undefined,
          dateType: undefined,
          containerType: undefined,
          campaignId: undefined
        });
      }
    case UPDATE_DATE_RANGE:
      {
        const {
          startDate,
          endDate,
          presetId
        } = action;
        return Object.assign({}, state, {
          startDate,
          endDate,
          dateType: presetId
        });
      }
    default:
      return state;
  }
};
export default filters;